"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var factory_1 = require("../types/factory");
exports.getLocalizationDictionary = function (text, params, knownPlaceholders) {
    var result = {
        text: text,
        knownPlaceholders: knownPlaceholders,
        localizableElements: [],
        domElements: [],
        jsxElements: []
    };
    var processPlaceholders = function (placeholders) {
        if (placeholders && placeholders.length > 0) {
            placeholders.forEach(function (knownPlaceholder) {
                var formattedPlaceholder = knownPlaceholder.toPascalCase();
                if (params.hasOwnProperty(formattedPlaceholder)) {
                    var value = params[formattedPlaceholder];
                    if (factory_1.TypeCheck.isJsxElement(value)) {
                        result.jsxElements.push({
                            key: formattedPlaceholder,
                            value: value
                        });
                    }
                    else if (factory_1.TypeCheck.isLocalizableElement(value)) {
                        result.localizableElements.push({
                            key: formattedPlaceholder,
                            value: { type: 'span', translationKey: value.translationKey }
                        });
                    }
                    else if (factory_1.TypeCheck.isDomElement(value)) {
                        if (knownPlaceholder.isTag) {
                            result.domElements.push({
                                key: formattedPlaceholder,
                                value: params[formattedPlaceholder],
                                body: knownPlaceholder.content
                            });
                            if (knownPlaceholder.content && knownPlaceholder.content.length > 0) {
                                processPlaceholders(knownPlaceholder.content);
                            }
                        }
                        else {
                            result.localizableElements.push({
                                key: formattedPlaceholder,
                                value: params[formattedPlaceholder]
                            });
                        }
                    }
                }
            });
        }
    };
    processPlaceholders(knownPlaceholders);
    var reportMissingPlaceholders = function () {
        var _loop_1 = function (key) {
            if (params.hasOwnProperty(key)) {
                var filter_1 = function (knownPlaceholder) {
                    return knownPlaceholder.toPascalCase() === key || ((!!knownPlaceholder.content) &&
                        knownPlaceholder.content.filter(filter_1).length > 0);
                };
            }
        };
        for (var key in params) {
            _loop_1(key);
        }
    };
    reportMissingPlaceholders();
    return result;
};
exports.getStringDictionary = function (params) {
    var result = {};
    for (var key in params) {
        if (params.hasOwnProperty(key)) {
            var element = params[key];
            if (typeof element === 'string' || typeof element === 'number') {
                result[key] = element.toString();
            }
        }
    }
    return result;
};
